var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "review-mobile-note d-md-none"
  }, [_vm._v(" Clicking "), _c('strong', [_vm._v(_vm._s(_vm.action))]), _vm._v(" saves this section and opens the next tab. Continue through each tab to "), _c('strong', [_vm._v("Review & Sign")]), _vm._v(" to complete your review. ")]);

}
var staticRenderFns = []

export { render, staticRenderFns }